import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Box, Button, ButtonMode, CalendarIcon } from 'edenred-ui';

import { createRules, FormFields } from '@epi-forms/helpers';
import {
  maxLength,
  required as requiredValidation
} from '@epi-helpers/formHelpers/validators';
import { IPersonalDataField } from '@epi-models/pages/Beneficiaries';
import { apiToDefaultDateFormat } from '@epi-helpers/dateHelper';
import { useModal } from '@epi-shared/hooks';
import { TerminationDateDialog } from '@epi-pages/Beneficiaries/components/TerminationDate/components/TerminationDateDialog';
import { StyledTextField } from '@epi-pages/Beneficiaries/BeneficiariesListStyles';

import { useEndOfFundsDateDialog } from './useEndOfFundsDateDialog';

export const EndOfFundsField = ({
  label,
  validate,
  name,
  required = false,
  disabled = false,
  isDataField = false
}: IPersonalDataField) => {
  const { control, watch } = useFormContext();
  const { isModalOpen, openModal, closeModal } = useModal();
  const { handleSetDate, handleSave, endOfBenefit, disableSave, errorText } =
    useEndOfFundsDateDialog(closeModal);
  const defaultValidators = [requiredValidation, maxLength(20)];
  const rules = createRules(validate || defaultValidators);
  const startDate = watch(FormFields.EndOfBenefit);

  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  const formattedValue = isDataField
    ? apiToDefaultDateFormat(value)
    : value ?? '';

  return (
    <Box>
      <StyledTextField
        id={name}
        label={label}
        value={formattedValue}
        onChange={onChange}
        readOnly={disabled}
        error={!!error}
        helperText={error?.message}
        required={required}
        InputProps={{
          endAdornment: (
            <Button
              id="containers.beneficiaries.detail.end_of_benefit"
              mode={ButtonMode.Link}
              onClick={openModal}
              type="button"
            >
              <CalendarIcon />
            </Button>
          )
        }}
        InputLabelProps={{ style: { paddingBottom: '50px' } }}
      />
      <TerminationDateDialog
        title={label}
        isOpen={isModalOpen}
        handleClose={closeModal}
        handleSetDate={handleSetDate}
        handleSave={handleSave}
        endOfBenefit={endOfBenefit}
        disableSave={disableSave}
        errorText={errorText}
        startDate={startDate}
        name={name}
      />
    </Box>
  );
};
